import { useRef, useState } from 'react';
import { toast } from 'sonner';
import { uid } from '../lib/model';

export const H = 3600e3;
export const LOG_COLORS = { perm: '#2563eb', green: '#16a34a', yellow: '#eab308', red: '#dc2626', missing: '#4c0519' };
// perm = blue; lift & shift: red from due time, yellow 12 h before, else green
export const loggerState = (l, now = Date.now()) => (l.missingAt ? 'missing' : l.mode === 'perm' ? 'perm' : now >= l.dueAt ? 'red' : l.dueAt - now <= 12 * H ? 'yellow' : 'green');
export const activeLoggers = (p) => (p?.loggers || []).filter((l) => !l.collectedAt);
// field result: collect, relocate (lift & shift) or mark missing; finding = { noise, note, at }
export const patchLogger = (updateProject, id, fn) => updateProject((p) => ({ ...p, loggers: (p.loggers || []).map((l) => (l.id === id ? { ...l, ...fn(l) } : l)) }));
// every spot where a logger heard noise (incl. collected and earlier lift & shift positions)
export const noiseSpots = (project) => (project?.loggers || []).flatMap((l) => [
  ...(l.history || []).map((h, i) => [h, `${l.id}-h${i}`]).filter(([h]) => h.finding?.noise).map(([h, id]) => ({ id, logId: l.id, name: l.name, lat: h.lat, lon: h.lon, at: h.finding.at, note: h.finding.note })),
  ...(l.finding?.noise ? [{ id: `${l.id}-c`, logId: l.id, name: l.name, lat: l.lat, lon: l.lon, at: l.finding.at, note: l.finding.note }] : []),
]);
export const fmtDuration = (ms, t) => { const h = Math.max(0, Math.round(ms / H)); return h >= 48 ? `${Math.round(h / 24)} ${t.lgDays}` : `${h} h`; };

export default function useLoggers({ t, project, updateProject, repId }) {
  const [arm, setArm] = useState(null);
  const [dlg, setDlg] = useState(null);
  const [selId, setSelId] = useState(null);
  const armRef = useRef(null);
  armRef.current = arm;
  const patch = (id, fn) => patchLogger(updateProject, id, fn);

  const onMap = (pt) => {
    const a = armRef.current;
    setArm(null);
    if (a.moveId) {
      const now = Date.now();
      patch(a.moveId, (l) => ({ history: [...(l.history || []), { lat: l.lat, lon: l.lon, placedAt: l.placedAt, removedAt: now }], lat: pt[0], lon: pt[1], placedAt: now, dueAt: l.mode === 'perm' ? null : now + (l.durMs || 24 * H) }));
      toast.success(t.lgMoved);
    } else setDlg({ pt });
  };
  const save = ({ name, mode, durMs }) => {
    const now = Date.now();
    const l = { id: uid('log'), name: name || `${t.lgTitle} ${(project.loggers || []).length + 1}`, mode, durMs: mode === 'perm' ? null : durMs, lat: dlg.pt[0], lon: dlg.pt[1], placedAt: now, dueAt: mode === 'perm' ? null : now + durMs, reportId: repId, history: [] };
    updateProject((p) => ({ ...p, loggers: [...(p.loggers || []), l] }));
    setDlg(null);
    toast.success(t.lgPlaced);
  };
  const collect = (id) => { setSelId(null); window.dispatchEvent(new CustomEvent('giss-lgplan-open', { detail: { tab: 'collect', id } })); };
  const found = (id) => { patch(id, () => ({ missingAt: null, finding: null })); toast.success(t.lcFoundOk); };
  const startMove = (id) => { setSelId(null); setArm({ moveId: id }); toast.message(t.lgTapNew, { duration: 6000 }); };
  return { arm, armRef, setArm, onMap, dlg, setDlg, save, selId, setSelId, collect, found, startMove, list: activeLoggers(project) };
}
